module.exports = __webpack_public_path__ + "img/Walls_text07_disappear.1097ce04.png";